import definitions from './team.json' with {type: 'json'};

export type TeamRoleId = 'head' | 'research' | 'coder' | 'planner' | 'designer' | 'writer' | 'analyst' | 'operator';
export interface TeamRole {
  id: TeamRoleId;
  name: string;
  shortName: string;
  discipline: string;
  jobTitle: string;
  description?: string;
  instruction: string;
  color: string;
  profile: {
    identity: readonly string[];
    responsibilities: readonly string[];
    workflow: readonly string[];
    completionChecks: readonly string[];
    handoff: readonly string[];
    memory: readonly string[];
    skills: readonly string[];
  };
}

/** team.json owns the names, responsibilities, and visual identities of the eight roles. */
export const TEAM_ROLES = definitions as readonly TeamRole[];
export function getTeamRole(id: string): TeamRole {
  const role = TEAM_ROLES.find(item => item.id === id);
  if (!role) throw new Error(`Unknown EightBots team role: ${id}`);
  return role;
}
